<template>
    <div>
      <section>
          <div class="container">
              <figure><img src="/static/images/index/i80banner.png" class="img-responsive"></figure>
          </div>
      </section>
      <section>
          <div class="container">
              <ol class="breadcrumb hidden-xs">
                  <li><a href="/">首頁</a></li>
                  <li><a href="/alliance">聯盟中心</a></li>
                  <li class="active">中心介紹</li>
              </ol>
              <div class="row">
                <div class="col-xs-12">
                    <h4 class="title">{{rowData.name}}</h4>
                </div>
                <div class="col-xs-12 m-t-10">
                    <p class="txt">{{rowData.description}}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3 col-sm-4 col-xs-6" v-for="(row, index) in companies">
                    <div class="store_list">
                        <div class="store_box">
                            <router-link :to="'/store/'+row.comid">
                                <figure class='pic justify'>
                                    <img :src="'https://files.i80.com.tw/images/product/'+row.com_image" class="img-responsive"/>
                                </figure>
                                <h5 class="title">{{row.com_name}}</h5>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
              <nav aria-label="...">
                  <ul class="pagination">
                      <li class="disabled">
                          <a href="#" aria-label="Previous">
                              <span aria-hidden="true">&laquo;</span>
                          </a>
                      </li>
                      <li class="active"><a href="#">1 <span class="sr-only">(current)</span></a></li>
                      <li class="disabled">
                          <a href="#" aria-label="Next">
                              <span aria-hidden="true">&raquo;</span>
                          </a>
                      </li>
                  </ul>
              </nav>
          </div>
      </section>
    </div>
  </template>
  
<script>
  import {mapActions, mapGetters} from 'vuex'
  
  export default {
    name: 'AllianceView',
    data () {
      return {
        apiurl: 'https://affiliate.i80.com.tw/',
        companies: [],
        rowData: {},
        userID: this.$store.getters.getUserID,
        storeData: '',
        keyword: ''
      }
    },
    mounted: function () {
      let id = this.$route.params.id
      this.$http.get(this.apiurl + 'api/alliance/' + id).then(function (res) {
        console.log(res)
        this.rowData = res.body
        this.companies = res.body.companies
      }, function () {
        console.log('loading alliance is failed.')
      })
    },
    methods: {
      ...mapActions([
        'GET_NEWS'
      ])
    },
    computed: {
      ...mapGetters({
        userID: 'getUserID'
      })
    },
    metaInfo: {
      title: '愛幫您-聯盟中心',
      meta: [{
        name: '愛幫您-聯盟中心',
        content: '這邊擁有最多元的聯盟店家選擇，且都經過平台層層把關。'
      }],
      link: [{
        rel: 'alliance',
        href: 'https://www.i80.com.tw/alliance'
      }]
    }
  }
</script>



// WEBPACK FOOTER //
// AllianceView.vue?3252de12